import { useEffect } from 'react'
import { supabase } from '@/lib/supabase'
import { useAuthStore } from '@/stores/authStore'

export function useUser() {
  const { setUser, setAccessToken } = useAuthStore((state) => state.auth)

  useEffect(() => {
    async function fetchUser() {
      const { data, error } = await supabase.auth.getUser()
      if (error) {
        console.error('Erro ao buscar usuário:', error.message)
      }

      if (data?.user) {
        setUser(data?.user || null)
      }
    }

    fetchUser()

    const { data: authListener } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session?.user) {
        setUser(session?.user)
      } else {
        setUser(null)
      }
    })

    return () => {
      authListener.subscription.unsubscribe()
    }
  }, [setUser, setAccessToken])
}
